import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import '../styles/ProjectTU.css'

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import KranIcon from '../website_images/Icons/kran.png'
import HausIcon from '../website_images/Icons/haus.png'
import GrundrissIcon from '../website_images/Icons/grundriss.png'
import ParkenIcon from '../website_images/Icons/parken.png'
import ScrollAnimation from '../components/ScrollAnimation';

const ProjectTU: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="container project-tu">
            <section className="project-tu-header page-hero" id="page-hero" />
            <section className="main-section fullbleed">
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <div id="team">
                        <h2>{t('projectTU33Header')}</h2>
                        <h1>{t('projectSaleTitle')}</h1>
                        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('projectTUDescription')) }}>
                        </p>
                    </div>
                </ScrollAnimation>
            </section>

            <section className="section-investmentProducts fullbleed">
                <div className="company-inner">
                    <ScrollAnimation animation="fadeInUp" delay={0.1}>
                        <div className="projecttu-slider-section" id="brand">
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={KranIcon} alt="Kran icon" className='icons' />
                                    <h2>{t('constructionStart')}</h2>
                                </div>
                                <span>{t('constructionStartDate')}</span>
                            </div>
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={HausIcon} alt="Haus icon" className='icons' />
                                    <h2>{t('completion')}</h2>
                                </div>
                                <span>{t('completionDate')}</span>
                            </div>
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={GrundrissIcon} alt="Grundriss icon" className='icons' />
                                    <h2>{t('residentialUnits')}</h2>
                                </div>
                                <span>{t('residentialUnitsDetails')}</span>
                            </div>
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={ParkenIcon} alt="Parken icon" className='icons' />
                                    <h2>{t('parkingSpaces')}</h2>
                                </div>
                                <span>{t('parkingSpacesDetails')}</span>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            </section>

            <section className="main-section">
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <div className='projecttu-highlights'>
                        <h1>{t('projectHighlights')}</h1>
                        <ul>
                            <li>{t('projectHighlight1')}</li>
                            <li>{t('projectHighlight2')}</li>
                            <li>{t('projectHighlight3')}</li>
                            <li>{t('projectHighlight4')}</li>
                        </ul>
                    </div>
                </ScrollAnimation>
            </section>

            {/** <section className="section-investmentProducts fullbleed">
                <div className="company-inner">
                    <ScrollAnimation animation="fadeInUp" delay={0.1}>
                        <div className='projecttu-section'>
                            <h1>{t('integratedRealEstateKnowhow')}</h1>
                            <h2>{t('strongGroupSystem')}</h2>
                            <p>{t('integratedRealEstateDescription')}</p>
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation animation="fadeInUp" delay={0.1}>
                        <div className="contact-button-section company-contact">
                        <Link to='/unternehmen' className="contact-button">
                            {t('discoverCompanies')}
                        </Link>
                    </div>
                    </ScrollAnimation>
                    
                </div>
            </section>*/}
            <section className="main-section fullbleed">
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <div>
                        <h1>{t('projectInterestTitle')}</h1>
                        <h2>{t('projectInterestDescription')}</h2>
                        <div className="contact-button-section">
                            <Link to='/kontakt' className="knowhow-button-section projecttu-button">{t('requestProjectProfile')}</Link>
                        </div>
                    </div>

                </ScrollAnimation>
            </section>
        </div>
    );
};

export default ProjectTU;
